export default {
  stats: {
    title: "Stats",
    tabs: {
      team: "Team Stats",
      player: "Player Stats",
    },
    empty: {
      unavailable: "Stats unavailable right now.",
    },
    filters: {
      titles: {
        qualifier: "Qualifier",
        type: "Type",
        position: "Position",
      },
      plurals: {
        qualifier: "Qualifiers",
        type: "Types",
        position: "Positions",
      },
      options: {
        type: {
          offensive: "Offensive",
          defensive: "Defensive",
        },
      },
    },
  },
};
